import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private https: HttpClient) {}

  sendEmail(obj) {
    // return this.https.post(
    //   ' https://limitless-citadel-69513.herokuapp.com/sendmail',
    //   obj
    // ); Old Deployment
    return this.https.post('https://vercel-mail-xi.vercel.app/sendmail', obj);
  }
}
